( function() {
	var $ = require('jquery');
	require('featherlight');
	require('featherlight/src/featherlight.gallery.js');

	// $('a.galleries__link').featherlightGallery({
	// 	openSpeed: 1000
	// });
	//
	jQuery(document).ready(function($) {
		$("a.galleries__link").featherlightGallery({
			openSpeed: 300,
			previousIcon: '<i class="icon-left-open-big"></i>',
   			nextIcon: '<i class="icon-right-open-big"></i>',
			afterClose:  function() {

			}
		});
	});
})();
